import React, { Component } from 'react';

export default class MetricsFilterItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }


    render() {

        let textStyle = {}
        if (this.props.searchTop === this.props.num) {
            textStyle.color = '#49ca75';
        }

        return (
            <div onClick={this.props.onClick} className="metrics-filter-item-outer">
                <div className="metrics-filter-item-text" style={textStyle}>{this.props.text}</div>
            </div>
        );
    }
}